import type { ICoupon, IDiscountActivity } from '@wegic/price-ui';
import type {
  AnonymousCredits,
  AnonymousLatestPaidEmail,
  AnonymousTrialCashierParams,
  AnonymousTrialCashierSession,
  CreditPurchaseQuota,
  CreditSummary,
  IntegralLogsData,
  IUserPoints,
  QueryIntegralLogsParams,
  RemixCreditProduct,
} from './types';
import { agentsRequest, assetsRequest } from '../request';

/**
 * 查询用户当前积分数量
 */
export function getUserPoints() {
  return assetsRequest.get<IUserPoints>('/integral/v1/user/property');
}

/** 查询用户积分分类汇总 */
export function getCreditSummary(userId: string) {
  return assetsRequest.get<CreditSummary>(`/integral/v1/user/credit-summary/${userId}`);
}

/**
 * 查询匿名用户当前积分数量
 */
export function getAnonymousCredits() {
  return agentsRequest.get<AnonymousCredits>('/projects/v1/anonymous/credit');
}

/** 创建匿名用户 299 试用包支付会话。 */
export async function createAnonymousTrialCashierSession(params: AnonymousTrialCashierParams) {
  const response = await assetsRequest.post<AnonymousTrialCashierSession>(
    '/integral/v1/anonymous/299/cashier',
    params,
    {
      hideCodeErrorMessage: true,
      hideHTTPErrorMessage: true,
    },
  );

  return response.data;
}

/** 查询当前匿名会话最近一次 299 支付使用的邮箱。 */
export async function getAnonymousLatestPaidEmail(timeout?: number) {
  const response = await assetsRequest.get<AnonymousLatestPaidEmail>(
    '/integral/v1/anonymous/299/latest-paid-email',
    {
      hideCodeErrorMessage: true,
      hideHTTPErrorMessage: true,
      timeout,
    },
  );

  return response.data;
}

/**
 * 查询用户优惠券列表
 */
export function getUserCoupon() {
  return assetsRequest.get<ICoupon[]>('/integral/v1/user/coupon');
}

/**
 * 查询当前生效的折扣促销活动
 */
export function getActiveDiscountActivity() {
  return assetsRequest.get<IDiscountActivity | null>('/promotion/v1/discount-activity/active');
}

/**
 * 查询积分日志列表
 */
export function getIntegralLogs(params: QueryIntegralLogsParams) {
  return agentsRequest.post<IntegralLogsData>('/credit/v1/logs', {
    pageData: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
    },
  });
}

/**
 * 查询用户积分购买配额（已购 / 上限 / 剩余）
 * 接口：/api/assets/integral/v1/user/credit-purchase-quota
 */
export function getCreditPurchaseQuotaRequest() {
  return assetsRequest.get<CreditPurchaseQuota>('/integral/v1/user/credit-purchase-quota');
}

/**
 * 查询 Remix 100 积分包商品（含 productId / priceId / 单价）
 * 透传自后端 /api/assets/integral/v1/remix/credit-product
 * 单价单位为分（amount: 799 = $7.99）
 */
export function getRemixCreditProductRequest() {
  return assetsRequest.get<RemixCreditProduct>('/integral/v1/remix/credit-product');
}
